import { InvalidateQueryFilters, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

const useInvalidateQuery = () => {
  const queryClient = useQueryClient()

  const invalidate = useCallback(
    (queryKey: InvalidateQueryFilters) =>
      queryClient.invalidateQueries(queryKey),
    [queryClient]
  )

  return { invalidate }
}

export default useInvalidateQuery
